import { ResponsivePie } from "@nivo/pie";
import CircularProgress from "@mui/material/CircularProgress";

import classes from "./index.module.scss";
import CardContainer from "../cardContainer";

type Props = {
  title: string;
  overlaySubtitle: string;
  data: unknown[];
  total?: number;
  isLoading: boolean;
};

const PieChart = (props: Props) => {
  const { title, overlaySubtitle, data, isLoading, total } = props;

  return (
    <CardContainer
      {...{ title }}
      style={{
        height: 300,
        width: "50%",
        position: "relative",
        textAlign: "center",
      }}
    >
      {isLoading ? (
        <CircularProgress style={{ alignSelf: "center", margin: "auto" }} />
      ) : (
        <>
          <ResponsivePie
            {...{ data }}
            fit
            enableArcLinkLabels={false}
            margin={{ top: 0, right: 50, bottom: 90, left: 50 }}
            colors={{ datum: "data.color" }}
            theme={{ fontSize: 14, textColor: "white" }}
            innerRadius={0.8}
            cornerRadius={3}
            padAngle={3}
          />
          <div className={classes.overlay}>
            <p className={classes.totalNumber}>{total}</p>
            <p className={classes.overlaySubtitle}>{overlaySubtitle}</p>
          </div>
        </>
      )}
    </CardContainer>
  );
};

export default PieChart;
